import { ServiceRequest } from "src/utils/service-request"
import { CALC_SETORIAL_PATH, CALC_GROUP_INDICATOR_PATH, CALC_GROUP_ACTIVE_PATH } from "src/utils/api-routes"

class CalcService {

    constructor() {
        this.serviceRequest = new ServiceRequest()
    }

    async loadEndpoint(endpoint) {
        return await this.serviceRequest.get(`${endpoint}?limit=10000`)
    }

    async createTableEndpoint(endpoint, body) {
        return await this.serviceRequest.post(`${endpoint}`, body)
    }

    async updateTableEndpoint(endpoint, id, body) {
        return await this.serviceRequest.patch(`${endpoint}/${id}`, body)
    }

    async deleteTableEndpoint(endpoint, id) {
        return await this.serviceRequest.delete(`${endpoint}/${id}`)
    }

    async recuperaDadosSetor(input, value) {
        return this.serviceRequest.get(`${CALC_SETORIAL_PATH}?${input}=${value}`)
    }

    async recuperaGrupoAtivos(tiposEmissao = ['Corporate', 'IF', 'IF_IQ', 'Soberano']) {
        const response = await this.serviceRequest.get(`${CALC_GROUP_ACTIVE_PATH}`)
        const data = response?.body?.results || []

        return data
            .filter(item => tiposEmissao.includes(item.TipoEmissao))
            .map(item => ({
                value: item.TipoAtivo,
                label: `${item.TipoAtivo} (${item.GrupoAtivos})`
            }))
    }
    async recuperaIndicador() {
        const response = await this.serviceRequest.get(CALC_GROUP_INDICATOR_PATH)


        const data = response?.body?.results || []


        return data.map(item => ({
            indicador: item.Indicador
        }))
    }



}

export default CalcService